module.exports = __webpack_public_path__ + "static/media/girl_blink.33c48971.gif";